<!-- Content -->
<div class="flex flex-1 overflow-auto justify-content-center">
  <!-- Form -->
  @if (linkForm) {
    <medsurf-design-form-control-form
      [formGroup]="linkForm"
      [class]="'w-full'"
      (onSubmit)="onSubmit()">
      @if ({
        slideLayersArray: (slideAuthorFacade.slideLayersArray$ | async) || [],
        slideImagesArray: (slideAuthorFacade.slideImagesArray$ | async) || [],
        slideGroupsArray: (slideAuthorFacade.slideGroupsArray$ | async) || []
      }; as annotationDialogData) {
        <!-- Layers -->
        @if (annotationDialogData.slideLayersArray.length > 0) {
          <medsurf-design-form-control-input-dropdown
            [autofocus]="true"
            [control]="linkForm.controls.layer"
            [options]="annotationDialogData.slideLayersArray"
            [label]="'global.layers'"
          [placeholder]="'global.layers'"></medsurf-design-form-control-input-dropdown>
        }
        <!-- Images -->
        @if (annotationDialogData.slideImagesArray.length > 0 && linkForm.value['layer']) {
          <medsurf-design-form-control-input-dropdown
            [control]="linkForm.controls.image"
            [options]="annotationDialogData.slideImagesArray"
            [label]="'global.images'"
          [placeholder]="'global.images'"></medsurf-design-form-control-input-dropdown>
        }
        <!-- Groups -->
        @if (annotationDialogData.slideGroupsArray.length > 0) {
          <medsurf-design-form-control-input-dropdown
            [control]="linkForm.controls.group"
            [options]="annotationDialogData.slideGroupsArray"
            [label]="'global.groups'"
          [placeholder]="'global.groups'"></medsurf-design-form-control-input-dropdown>
        }
      }
      <!-- Submit -->
      <medsurf-design-form-control-input-submit [label]="'global.save_changes'"
      [disabled]="linkForm.invalid"></medsurf-design-form-control-input-submit>
    </medsurf-design-form-control-form>
  }
</div>